module.exports = "<div align=\"center\">\n  <h2 mat-dialog-title>{{data.title}}</h2>\n\n  <mat-dialog-content>\n    <strong>{{ data.content }}</strong>\n  </mat-dialog-content>\n\n  <mat-dialog-actions align=\"center\">\n    <button class=\"confirm-button\" mat-raised-button (click)=\"onCloseConfirm()\">OK</button>\n  </mat-dialog-actions>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialog/dialog.component.html
// module id = ./src/app/components/dialog/dialog.component.html
// module chunks = main